import moment from 'moment';

const utils = {
  convertToBlob(documentFile) {
    const blob = this.getBlobConvertion(documentFile);

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  getBlobConvertion(documentFile) {
    const byteArray = this.convertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  convertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  },
  isEmpty(value) {
    for (let prop in value) {
      if (value[prop] != null && value[prop] != undefined && value[prop] != '')
        return false;
    }
    return true;
  },
  async sleep(ms) {
    new Promise((r) => setTimeout(r, ms));
  },
  yesterday() {
    return moment()
      .subtract(1, 'day')
      .startOf('day')
      .toDate();
  },
  today() {
    return moment()
      .subtract(1, 'day')
      .toDate();
  },
  subtract(date, amount, unit) {
    return moment(date)
      .subtract(amount, unit)
      .toDate();
  },
};

export default utils;
